export const ERRORS = {
  USER_UPDATING_ERROR_BECAUSE_CPF_ALREADY_REGISTERED:
    "Identificamos que o CPF informado já está em uso. Para vincular este perfil ao seu CPF, por favor, autentique-se utilizando o seu CPF.",
  GENERIC_ERROR:
    "Não foi possível realizar a solicitação. Tente novamente mais tarde.",
};
